<template>
  <a-range-picker class="ant-picker-custom" v-bind="$attrs" :style="pickerStyle"
    :popup-class-name="computedPopupClassName" :popup-style="computedPopupStyle">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </a-range-picker>
</template>

<script setup lang="ts">
import { computed, type CSSProperties } from 'vue'

interface Props {
  borderColor?: string
  todayBackgroundColor?: string
  popupClassName?: string
  popupStyle?: CSSProperties
}

const props = defineProps<Props>()

const pickerStyle = computed(() => ({
  '--ant-picker-custom-border-color': props.borderColor || '#C5C5D3'
}) as CSSProperties)

const computedPopupClassName = computed(() => {
  return ['ant-picker-custom-popup', props.popupClassName].filter(Boolean).join(' ')
})

const computedPopupStyle = computed(() => ({
  ...props.popupStyle,
  '--ant-picker-custom-today-background-color': props.todayBackgroundColor,
  '--ant-picker-custom-selected-background-color': '#319456',
  '--ant-picker-custom-range-hover-border-color': '#319456',
  '--ant-picker-custom-range-hover-background-color': '#E5E5CD',
  '--ant-picker-custom-range-edge-hover-background-color': '#F0FBD9',
  '--ant-picker-custom-range-background-color': '#F6FEE6'
}) as CSSProperties)

defineOptions({
  name: 'AntPicker',
  inheritAttrs: false
})
</script>

<style lang="less">
.ant-picker-custom.ant-picker-focused {
  // box-shadow: 0 0 0 2px rgba(49, 148, 86, 0.23);
}

.ant-picker-custom.ant-picker-range .ant-picker-active-bar {
  height: 3px;
  // background: #319456;
}

.ant-picker-custom-popup .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  color: #fff;
  border: 1px solid #319456;
}

.ant-picker-custom {
  border-color: var(--ant-picker-custom-border-color) !important;

  &:hover,
  &.ant-picker-focused {
    border-color: var(--ant-picker-custom-border-color) !important;
  }

  .ant-picker-input>input {
    text-align: center;
  }
}

.ant-picker-custom-popup {
  .ant-picker-cell-in-view.ant-picker-cell-today:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end) {
    .ant-picker-cell-inner {
      background-color: var(--ant-picker-custom-today-background-color) !important;
    }
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected,
  .ant-picker-cell-in-view.ant-picker-cell-range-start,
  .ant-picker-cell-in-view.ant-picker-cell-range-end {
    .ant-picker-cell-inner {
      background-color: var(--ant-picker-custom-selected-background-color) !important;
    }
  }

  .ant-picker-cell-range-hover::after,
  .ant-picker-cell-range-hover-start::after,
  .ant-picker-cell-range-hover-end::after {
    border-color: var(--ant-picker-custom-range-hover-border-color) !important;
  }

  .ant-picker-date-panel {

    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,
    .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {
      background-color: var(--ant-picker-custom-range-edge-hover-background-color) !important;
    }
  }

  .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
  .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
    background-color: var(--ant-picker-custom-range-background-color) !important;
  }

  .ant-picker-panel-has-range-hover {

    .ant-picker-cell-in-view.ant-picker-cell-in-range::before,
    .ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
    .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
      background-color: var(--ant-picker-custom-range-hover-background-color) !important;
    }
  }
}
</style>
